import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Mail, ChevronDown } from "lucide-react";

export function EmailSendDialog({ open, onOpenChange, initialData, onSend }) {
  const [email, setEmail] = useState("");
  const [cc, setCc] = useState("");
  const [bcc, setBcc] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const clientEmails = initialData?.clientEmails || [];

  useEffect(() => {
    if (open && initialData) {
      setEmail(initialData.email || "");
      setCc(initialData.cc || "");
      setBcc(initialData.bcc || "");
      setSubject(initialData.subject || "");
      setMessage(initialData.message || "");
    }
  }, [open, initialData]);

  const handleSend = () => {
    onSend({ email, cc, bcc, subject, message });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="email-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Mail size={18} className="text-indigo-600" /> Envoi {initialData?.docNumber || ""}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs text-slate-500 uppercase">Email destinataire *</Label>
            {clientEmails.length > 1 ? (
              <div className="space-y-1.5">
                <select value={email} onChange={e => setEmail(e.target.value)}
                  className="w-full h-9 rounded-md border border-slate-200 bg-white px-3 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  data-testid="email-select">
                  {clientEmails.map(e => <option key={e} value={e}>{e}</option>)}
                  <option value="__custom">Autre adresse...</option>
                </select>
                {email === "__custom" || !clientEmails.includes(email) ? (
                  <Input type="email" value={email === "__custom" ? "" : email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="Saisir un autre email" className="text-xs h-8" data-testid="email-custom-input" />
                ) : null}
              </div>
            ) : (
              <Input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="client@exemple.fr" data-testid="email-recipient-input" />
            )}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div>
              <Label className="text-xs text-slate-500 uppercase">Cc</Label>
              <Input type="email" value={cc} onChange={e => setCc(e.target.value)} placeholder="copie@exemple.fr" data-testid="email-cc-input" />
            </div>
            <div>
              <Label className="text-xs text-slate-500 uppercase">Cci</Label>
              <Input type="email" value={bcc} onChange={e => setBcc(e.target.value)} placeholder="copie-cachee@exemple.fr" data-testid="email-bcc-input" />
            </div>
          </div>
          <div>
            <Label className="text-xs text-slate-500 uppercase">Sujet</Label>
            <Input value={subject} onChange={e => setSubject(e.target.value)} data-testid="email-subject-input" />
          </div>
          <div>
            <Label className="text-xs text-slate-500 uppercase">Message</Label>
            <Textarea value={message} onChange={e => setMessage(e.target.value)} rows={12} className="text-sm" data-testid="email-message-input" />
          </div>
          <p className="text-xs text-slate-400">Le detail de la facture et la signature de votre société (adresse, telephone, IBAN) seront inclus automatiquement dans l'email.</p>
          <Button onClick={handleSend} className="w-full bg-indigo-600 hover:bg-indigo-700 text-white uppercase text-xs font-bold tracking-wider" data-testid="send-email-btn">
            <Mail size={16} className="mr-2" /> Envoyer
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
